/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cookie_Policy_TitleInputs */

const en_cookie_policy_title = /** @type {(inputs: Cookie_Policy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cookie policy`)
};

const es_cookie_policy_title = /** @type {(inputs: Cookie_Policy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Política de cookies`)
};

const fr_cookie_policy_title = /** @type {(inputs: Cookie_Policy_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Politique de cookies`)
};

/**
* | output |
* | --- |
* | "Cookie policy" |
*
* @param {Cookie_Policy_TitleInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" }} options
* @returns {LocalizedString}
*/
export const cookie_policy_title = /** @type {((inputs?: Cookie_Policy_TitleInputs, options?: { locale?: "en" | "es" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cookie_Policy_TitleInputs, { locale?: "en" | "es" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cookie_policy_title(inputs)
	if (locale === "es") return es_cookie_policy_title(inputs)
	return fr_cookie_policy_title(inputs)
});